const post_url: string = 'agency-admin';

export const CreateAgency = async (agency: any): Promise<any> => {
       return await $fetch(post_url, {
              method: "POST", headers: FetchHeader(), body: agency, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GetAllAgencies = async (): Promise<any> => {
       return await $fetch(post_url, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GetAgencyProducts = async (agencyId: string): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}/products`, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GetAgency = async (agencyId: string): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}`, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GetAgencyDelegate = async (agencyId: string): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}/delegates`, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const UpdateAgency = async (agency: any): Promise<any> => {
       return await $fetch(`${post_url}/${agency.uid}`, {
              method: "PUT", headers: FetchHeader(), body: agency, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const DeleteAgency = async (agencyId: string): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}`, {
              method: "DELETE", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const AddUsersAgency = async (agencyId: string, members: any): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}/addMembers`, {
              method: "POST", headers: FetchHeader(), body: members, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GetAgencySectors = async (agencyId: string): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}/sectors`, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const AddHealcentersSubsecteur = async (agencyId: string, subsecteurId: string, members: any): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}/assignHealthCenter/subSectors/${subsecteurId}`, {
              method: "POST", headers: FetchHeader(), body: members, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GetAvalableTeamManager = async (agencyId: string): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}/delegateWithNoTeam`, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GetAvalableTeamSupervisor = async (agencyId: string): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}/supervisor`, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const SetUserAsSuppervisor = async (agencyId: string, userId: string): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}/setAsSupervisor/${userId}`, {
              method: "POST", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const ImportAgencyAndDelegate = async (data: any[]): Promise<any> => {
       for (let x of data) {
              delete x.$id;
       }
       return await $fetch(`${post_url}/upload`, {
              method: "POST", headers: FetchHeader(), body: { data }, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const UploadAgencyProducts = async (products: any[]): Promise<any> => {
       for (let x of products) {
              delete x.$id;
              delete x.agencyName;
              delete x.productName;
       }
       return await $fetch(`${post_url}/assign/products`, {
              method: "POST", headers: FetchHeader(), body: { data: products }, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const UploadUsersAgency = async (users: any[]): Promise<any> => {
       for (let x of users) {
              delete x.$id;
       }
       return await $fetch(`${post_url}/assign/delegates`, {
              method: "POST", headers: FetchHeader(), body: { data: users }, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const downloadAgencies = async (fields: any): Promise<any> => {
       return await $fetch(`${post_url}/download`, {
              method: "POST", headers: FetchHeader(), body: { params: fields }, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const agencyTeamsStats = async (fields: any, agencyId: string): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}/stats`, {
              method: "POST", headers: FetchHeader(), body: fields, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GetAgencyReport = async (
       agencyId: string,
       delegateId: string = '',
       status: string = '',
       teamId: string = '',
       startDate: string = '',
       endDate: string = '',
       page: number = 1,
       pageSize: number = useRuntimeConfig().public.pageSize
): Promise<any> => {
       const params = {
              delegateId,
              status,
              teamId,
              startDate,
              endDate,
              page,
              pageSize,
       };
       const filteredParams = Object.entries(params).reduce((acc: any, [key, value]) => {
              if (value !== '' && value !== null) {
                     acc[key] = value;
              }
              return acc;
       }, {});

       const queryString = new URLSearchParams(filteredParams).toString();
       const url = `${post_url}/${agencyId}/delegate-appointement-report?${queryString}`;

       return await $fetch(url, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GetAgencyUsers = async (agencyId: string): Promise<any> => {
       return await $fetch(`${post_url}/${agencyId}/delegates`, {
              method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const RemoveDelegateInAgency = async (data: any): Promise<any> => {
       return await $fetch(`${post_url}/remove-delegate`, {
              method: "POST", headers: FetchHeader(), body: data, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const RemoveProductInAgency = async (data: any): Promise<any> => {
       return await $fetch(`${post_url}/remove-product`, {
              method: "POST", headers: FetchHeader(), body: data, baseURL: useRuntimeConfig().public.apiBaseUrl
       });
};

export const GetAgencyStats = async (agencyId: string): Promise<any> => {
        return await $fetch(`${post_url}/details/${agencyId}`, {
               method: "GET", headers: FetchHeader(), baseURL: useRuntimeConfig().public.apiBaseUrl
        });
};

// Composable for managing agencies with reactive state
export const useAgencies = () => {
    const agencies = ref<any[]>([]);
    const loading = ref(false);
    const totalElement = ref(0);

    const getAgencies = async () => {
        loading.value = true;
        try {
            const res = await GetAllAgencies();
            agencies.value = res.agencies || [];
            totalElement.value = res.totalCount || 0;
        } catch (error) {
            console.error(error);
        } finally {
            loading.value = false;
        }
    };

    return {
        agencies: readonly(agencies),
        loading: readonly(loading),
        totalElement: readonly(totalElement),
        getAgencies
    };
};

export const getGlobalAgencyStats = async (dateRange?: { startDate: string; endDate: string }) => {

       // Default to current month if no date range provided
       const now = new Date();
       const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
       const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

       const defaultRange = {
              startDate: startOfMonth.toISOString(),
              endDate: endOfMonth.toISOString()
       };

       const range = dateRange || defaultRange;

       return await $fetch(`${post_url}/simple-stats`, {
              method: 'POST',
              body: range,
              baseURL: useRuntimeConfig().public.apiBaseUrl,
              headers: FetchHeader()
       });



};


export const getAgencyOverviewStats = async (id: string) => {

              return await $fetch(`${post_url}/${id}/overview-stats`, {
                      method: 'GET',
                      headers: FetchHeader(),
                      baseURL: useRuntimeConfig().public.apiBaseUrl
               });


};

export const CheckNewArticleStatus = async (agencyId: string): Promise<{ isNewArticle: boolean }> => {
  return await $fetch(`${post_url}/${agencyId}/checkNewArticleStatus`, {
    method: "GET",
    headers: FetchHeader(),
    baseURL: useRuntimeConfig().public.apiBaseUrl
  });
};

export const MarkNewArticleAsViewed = async (agencyId: string): Promise<void> => {
  await $fetch(`${post_url}/${agencyId}/markNewArticleAsViewed`, {
    method: "PUT",
    headers: FetchHeader(),
    baseURL: useRuntimeConfig().public.apiBaseUrl
  });
};